import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateCreateVacancy = {
  createVacancy: { data: null, loading: false, error: null },
};

export const createVacancy = createAsyncThunk('user/createVacancy', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .post(`${process.env.REACT_APP_SERVER_API}/vacancies/`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response);
    });
});

export const reducerCreateVacancy = {
  [createVacancy.pending]: (state) => {
    state.createVacancy.loading = true;
    state.createVacancy.error = null;
  },
  [createVacancy.fulfilled]: (state, action) => {
    state.createVacancy.loading = false;
    state.createVacancy.data = action.payload;
    state.createVacancy.error = null;
  },
  [createVacancy.rejected]: (state, action) => {
    state.createVacancy.loading = false;
    state.createVacancy.error = action;
  },
};
